import {IPreviewProps} from "./Preview";

export function VideoPreview({path}: IPreviewProps) {

    return (
        <video key={path} controls>
            <source src={path}/>
        </video>
    );
}
